var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "gwd-inline-row gwd-align gwd-jd-rank",
      class: _vm.additionalClass,
      style: `margin-top: ${_vm.mt}px`,
    },
    [
      _c("img", {
        staticStyle: { width: "72px", height: "18px" },
        attrs: {
          src:
            (_vm.location.hostname.includes("bijiago") ? "/bjg" : "") +
            `/images/rank/jdranklabel.svg`,
          alt: "",
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "gwd-rank-list gwd-row gwd-align",
          class: _vm.data.length > 1 ? "gwd-rotate" : "",
          staticStyle: { position: "relative" },
        },
        [
          _c(
            "a",
            {
              staticClass: "gwd-row gwd-align gwd-rank-first",
              attrs: {
                title: _vm.data[0].rname,
                href: _vm.data[0].rurl,
                target: "_blank",
              },
            },
            [
              _c("span", { staticClass: "font12" }, [
                _c("span", { staticClass: "gwd-mw" }, [
                  _vm._v(_vm._s(_vm.data[0].rname)),
                ]),
                _vm.data[0].rank
                  ? _c("span", [_vm._v("第" + _vm._s(_vm.data[0].rank) + "名")])
                  : _vm._e(),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm.data.length > 1
            ? _c(
                "div",
                { staticClass: "gwd-rank-addition" },
                _vm._l(_vm.addition, function (item) {
                  return _c(
                    "a",
                    {
                      key: item.rurl,
                      attrs: {
                        title: item.rname,
                        href: item.rurl,
                        target: "_blank",
                      },
                    },
                    [
                      _c("span", { staticClass: "font12 gwd-mw" }, [
                        _vm._v(_vm._s(item.rname)),
                      ]),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }